import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../lib/utils';

export function EnterprisePriceLabel({
  variant = 'default',
  className,
}: {
  variant?: 'default' | 'onDark';
  className?: string;
}): React.JSX.Element {
  const { t } = useTranslation('pricing');

  return (
    <div className={cn('space-y-2', className)}>
      <p
        className={cn(
          'font-serif text-xl font-normal leading-snug tracking-tight md:text-2xl',
          variant === 'onDark' ? 'text-white/75' : 'text-[var(--ir-muted)]'
        )}
      >
        {t('enterprise.priceLabel')}
      </p>
      <p
        className={cn(
          'max-w-xs text-sm leading-relaxed',
          variant === 'onDark' ? 'text-white/75' : 'text-[var(--ir-muted)]'
        )}
      >
        {t('enterprise.priceBody')}
      </p>
    </div>
  );
}
